const createStorageLens = require('./createStorageLens');

/**
 * Creates a StorageLens where the logical storage is identical to the
 * underlying inner storage. No transformation is applied.
 *
 * This lens is used when the inner storage already represents the logical
 * structure directly (e.g. an in‑memory storage implementation).
 *
 * @returns {StorageLens}
 * A lens whose getter returns the inner storage as-is, and whose setter
 * writes directly to the same inner storage.
 */
function createStorageLensForDedicatedStorage() {
  return createStorageLens(
    (innerStorage) => innerStorage, // Getter: return inner storage as-is
    (val, innerStorage) => {
      if (val === null) {
        innerStorage.clear();
      }
      // Setter: no transformation needed
      return innerStorage;
    }
  );
}

module.exports = createStorageLensForDedicatedStorage;
